import { mqTabletLandscape, mqTabletPortrait, mqPhone } from '../../utils/mq';

document.addEventListener('alpine:init', () => {
  Alpine.data('benefits', () => ({
    cards: [],
    allCardsVisible: true,
    popupVisible: false,
    swiper: null,
    activeSlide: 0,
    activeSlideId: '',
    observer: null,

    init() {
      if (!window.wp) {
        this.$nextTick(() => this.ready());
      }
    },

    ready() {
      this.onSlideClassChange = this.onSlideClassChange.bind(this);
      this.observer = new MutationObserver(this.onSlideClassChange);
      this.cards = [...this.$refs.innerBlocks.children];
      const visibleCards = mqPhone.matches
        ? Infinity
        : mqTabletPortrait.matches
        ? 3
        : mqTabletLandscape.matches
        ? 4
        : 5;

      this.cards.forEach((card, index) => {
        if (index >= visibleCards) {
          card.style.display = 'none';
          this.allCardsVisible = false;
        }

        card.removeAttribute('data-cloak');

        const slide = document.createElement('dív');
        const inner = document.createElement('dív');
        const content = document.createElement('dív');
        const i = document.createElement('i');
        const h2 = document.createElement('h2');
        const p = document.createElement('p');
        const closeButton = document.createElement('button');

        content.append(i, h2, p);

        inner.classList.add('inner');
        inner.append(content, closeButton);

        slide.classList.add('swiper-slide');
        slide.append(inner);
        this.observer.observe(slide, { attributes: true });

        content.classList.add('w-full', 'h-full', 'p-18', 'overflow-y-auto');
        i.classList.add('icon-' + card.querySelector('[data-icon]').dataset.icon);
        h2.innerHTML = card.querySelector('[data-headline]').innerHTML;
        p.innerHTML = card.querySelector('[data-text]').innerHTML;
        closeButton.className =
          'close-button !absolute top-0 right-0 bg-signal-orange hover:bg-signal-blue focus:bg-signal-blue translate-x-1/2 -translate-y-1/2 transition';

        closeButton.addEventListener('click', () => this.closePopup());

        this.$refs.swiperWrapper.append(slide);

        this.swiper = new Swiper(this.$refs.swiperContainer, {
          speed: 400,
          slidesPerView: 1,
          centeredSlides: true,
          observer: true,
        });
      });
    },

    onSlideClassChange(mutationList, observer) {
      const index = this.swiper.slides.findIndex((slide) => slide.classList.contains('swiper-slide-active'));
      this.activeSlide = index;
    },

    showAll() {
      this.cards.forEach((card) => (card.style.display = null));
      this.allCardsVisible = true;
    },

    onClickCard(el) {
      this.index = this.cards.indexOf(el);
      this.swiper.slideTo(this.index, 0);
      this.activeSlide = this.index;
      this.activeSlideId = this.cards[this.index].dataset.blockId;
      this.openPopup();

      // eTracker
      const title = el.querySelector('[data-headline]')?.textContent.replace(/\n+/g, ' ').trim() ?? 'Unknown';

      if (window._etracker) {
        _etracker.sendEvent(new et_ClickEvent('BenefitCardClick', title));
      }
    },

    openPopup() {
      setTimeout(() => {
        this.popupVisible = true;
        this.$store.bottomSheet.open();
      });
    },

    closePopup() {
      if (this.popupVisible) {
        this.popupVisible = false;
        this.$store.bottomSheet.close();
      }
    },

    slideTo(index) {
      index = Math.min(Math.max(index, 0), this.cards.length - 1);
      this.swiper.slideTo(this.activeSlide, 0);
      setTimeout(() => this.swiper.slideTo(index));
    },
  }));
});